import React from 'react';
import { StaticPageWithData } from '../components/StaticPage';
import PageMeta from '../components/PageMeta';

/**
 * Página de Términos de Uso
 * 
 * Esta página consume datos dinámicos de la API backend a través del componente
 * StaticPageWithData, garantizando contenido siempre actualizado.
 * 
 * Funcionalidades incluidas:
 * - Carga dinámica de contenido vía API
 * - Manejo de errores robusto con opción de reintentar
 * - Estados de carga visual
 * - SEO optimizado con meta tags dinámicas
 * - Breadcrumbs para navegación
 * - Diseño responsivo
 * - Accesibilidad (ARIA labels)
 */
const TermsOfService: React.FC = () => {
  return (
    <div className="terms-of-service-page">
      <PageMeta
        title="Términos de Uso - Café Tutoriales"
        description="Conozca los términos de uso y condiciones para utilizar la plataforma Café Tutoriales de forma responsable y segura."
        keywords="términos uso, condiciones, reglas, responsabilidades, cafe, tutorial"
        canonical="https://cafetutoriales.com/terminos-uso"
      />
      <StaticPageWithData
        pageType="terms"
      />
    </div>
  );
};

export default TermsOfService;